const config = require('./config.js');

export const URLAPI = config.ENV_URL_API;
export const WEBSOCKET = config.ENV_URL_WS;

export const KEY_MAPS = 'AIzaSyD7PLL5ULCA4UAvLrxxPynSjVbjaBjki1s';

export const USER_TYPES_PATH = "/user-types/list/";

export const RESPONSIBLES_PATH = "/scheduled/responsibles/list/";
export const RESPONSIBLE_CREATE_PATH = "/scheduled/responsible/create/";
export const RESPONSIBLE_UPDATE_PATH = "/scheduled/responsible/update/";

export const ASSIST_CONTROL_PATH = "/assist_control/list/";
export const CONSULTATIONS_PATH = "/assist_control/consultations/";
export const ASSIST_CONTROL_CREATE_PATH = "/assist_control/create/";
export const ASSIST_CONTROL_UPDATE_PATH = "/assist_control/update/";

export const STORES_ACCESS_PATH = "/assist_control/store/list/";
export const STORE_ACCESS_CREATE_PATH = "/assist_control/store/create/";
export const STORE_ACCESS_UPDATE_PATH = "/assist_control/store/update/";

export const PROVINCES_PATH = "/store/provinces/list/";
export const PROVINCE_CREATE_PATH = "/store/province/create/";
export const PROVINCE_UPDATE_PATH = "/store/province/update/";

export const CITIES_PATH = "/store/cities/list/";
export const CITY_CREATE_PATH = "/store/city/create/";
export const CITY_UPDATE_PATH = "/store/city/update/";

export const ZONES_PATH = "/store/zones/list/";
export const ZONE_CREATE_PATH = "/store/zone/create/";
export const ZONE_UPDATE_PATH = "/store/zone/update/";

export const STORES_PATH = "/store/list/";
export const STORE_CREATE_PATH = "/store/create/";
export const STORE_UPDATE_PATH = "/store/update/";

export const TEAMS_PATH = "/team/list/";
export const TEAM_CREATE_PATH = "/team/create/";
export const USERS_TEAMS_CREATE_PATH = "/team/user/create/";
export const USERS_TEAMS_DELETE_PATH = "/team/user/delete/";
export const TEAM_UPDATE_PATH = "/team/update/";

export const TOKEN_PATH = "/user/token/";
export const USERS_PATH = "/user/list/";
export const USERS_ACTIVE_PATH = "/user/active/list/";
export const USERS_UPDATE_PATH = "/user/update/";
export const USERS_UPDATE_PASSWORD_PATH = "/user/update-password/";
export const USERS_CREATE_PATH = "/user/create/";
export const USER_GROUPS_PATH = "/user/group-list/";
export const USER_GET_PATH = "/user/get/";
export const USER_GET_ALL_PERMISSIONS_PATH = '/user/permission-list/';
export const USER_CREATE_GROUP_PATH = '/user/group-create/';
export const USER_UPDATE_GROUP_PATH = '/user/group-update/';
export const USER_ACTIVATE_PATH = '/user/activate/';
export const USER_LOGOUT_PATH = '/user/logout/';
export const USER_PASSWORD_RESET_PATH = '/user/password/reset/';
export const USER_PASSWORD_RESET_CONFIRM_PATH = '/user/password/reset/confirm/';
export const USER_TYPE_PATH = '/user/type/';

export const CRITICAL_LEVELS_PATH = "/work/critical-level/list/";
export const CRITICAL_LEVEL_CREATE_PATH = "/work/critical-level/create/";
export const CRITICAL_LEVEL_UPDATE_PATH = "/work/critical-level/update/";

export const PERIODICITIES_PATH = "/work/periodicities/list/";

export const WORK_SHEETS_PATH = "/work/sheets/list/";
export const WORK_SHEET_CREATE_PATH = "/work/sheet/create/";
export const WORK_SHEET_UPDATE_PATH = "/work/sheet/update/";

export const WORK_PROCESS_PATH = "/work/process/list/";
export const WORK_PROCESS_CREATE_PATH = "/work/process/create/";
export const WORK_PROCESS_UPDATE_PATH = "/work/process/update/";

export const WORK_SUBPROCESS_PATH = "/work/sub-process/list/";
export const WORK_SUBPROCESS_CREATE_PATH = "/work/sub-process/create/";
export const WORK_SUBPROCESS_UPDATE_PATH = "/work/sub-process/update/";

export const WORK_ACTIVITIES_PATH = "/work/activities/list/";
export const WORK_ACTIVITY_CREATE_PATH = "/work/activity/create/";
export const WORK_ACTIVITY_TEAM_CREATE_PATH = "/work/activity-team/create/";
export const WORK_ACTIVITY_UPDATE_PATH = "/work/activity/update/";
export const WORK_ACTIVITY_TEAM_DELETE_PATH = "/work/activity-team/delete/";

export const WORK_ACTIVITY_ADITIONAL_DATA_CREATE_PATH = "/work/activity-aditional-data/create/";
export const WORK_ACTIVITY_ADITIONAL_DATA_DELETE_PATH = "/work/activity-aditional-data/delete/";

export const WORK_ACTIVITY_TEMPLATE_CREATE_PATH = "/work/activity-template/create/";
export const WORK_ACTIVITY_TEMPLATE_UPDATE_PATH = "/work/activity-template/update/";
export const WORK_ACTIVITY_TEMPLATE_DELETE_PATH = "/work/activity-template/delete/";

export const WORK_SUBPROCESS_RISK_CREATE_PATH = "/work/subprocess-risk/create/";
export const WORK_SUBPROCESS_RISK_UPDATE_PATH = "/work/subprocess-risk/update/";
export const WORK_SUBPROCESS_RISK_DELETE_PATH = "/work/subprocess-risk/delete/";

export const OBSERVATIONS_PATH = "/scheduled/observations/list/";
export const OBSERVATION_CREATE_PATH = "/scheduled/observation/create/";
export const OBSERVATION_UPDATE_PATH = "/scheduled/observation/update/";
export const WORK_SUBPROCESS_OBSERVATION_CREATE_PATH = "/scheduled/work-process-observation/create/";
export const WORK_SUBPROCESS_OBSERVATION_DELETE_PATH = "/scheduled/work-process-observation/delete/";

export const RESULT_STATES_PATH = "/scheduled/result-states/list/";
export const RESULT_STATE_CREATE_PATH = "/scheduled/result-state/create/";
export const RESULT_STATE_UPDATE_PATH = "/scheduled/result-state/update/";

export const ACTIVITIES_PATH = "/scheduled/activities/list/";
export const FILES_ACTIVITIES_PATH = "/scheduled/files-activities/list/";
export const ACTIVITIES_USER_TEAMS_PATH = "/scheduled/activity/user-teams/list/";
export const ACTIVITIES_USER_PATH = "/scheduled/activity/user/list/";
export const ACTIVITY_ITEM_PATH = "/scheduled/activity/item/";
export const ACTIVITY_CREATE_PATH = "/scheduled/activity/create/";
export const ACTIVITY_UPDATE_PATH = "/scheduled/activity/update/";
export const ACTIVITY_CONFIRM_PATH = "/scheduled/activity/confirm/";
export const ACTIVITY_LOG_CREATE_PATH = "/scheduled/activity/log/create/";

export const MONTHLY_MONITORING_PATH = "/scheduled/monthly-monitoring/list/";
export const PROCESS_MONTHLY_MONITORING_PATH = "/scheduled/process/monthly-monitoring/list/";

export const RESULTS_QUERY_PATH = "/scheduled/results-query/list/";
export const RESULTS_QUERY_ZONE_PATH = "/scheduled/results-query/zone/list/";
export const PROCESS_RESULT_QUERY_PATH = "/scheduled/process/result-query/list/";
export const DOWNLOAD_RESULT_QUERY_PATH = "/scheduled/process/result-query/download/";
export const EXCEL_RESULT_QUERY_PATH = "/scheduled/process/result-query/excel/";

export const MATRIX_REPORT_PATH = "/scheduled/matrix/download/";

export const FINDINGS_MATRIX_PATH = "/work/finding-matrix/list/";
export const FINDING_MATRIX_CREATE_PATH = "/work/finding-matrix/create/";
export const FINDING_MATRIX_UPDATE_PATH = "/work/finding-matrix/update/";

export const SOCIETIES_PATH = "/societies/list/";
export const SOCIETY_CREATE_PATH = "/societies/create/";
export const SOCIETY_UPDATE_PATH = "/societies/update/";

export const UPDATE_ACTIVITY_PATH = "/scheduled/update-acivity/list/";
export const UPDATE_ACTIVITY_CREATE_PATH = "/scheduled/update-acivity/create/";
export const UPDATE_ACTIVITY_UPDATE_PATH = "/scheduled/update-acivity/update/";

export var URL_GEOLOCALIZATION = 'https://nominatim.openstreetmap.org/reverse';

export const APP_NAME = "CSM";


